module.exports = __webpack_public_path__ + "img/1-2.638f7468.png";